
<template>
  <div class="tabbed-content">
    <datatable
        :source='contactlog'
        :isLoading='isLoading'
      >
      <datatable-column
        v-for='(column, index) in columns'
        :id='column.id'
        :label='column.label'
        :key='index'
        :sortKey='column.sort'>
      </datatable-column>

      <template slot="searchLeft">
        <div class="buttons">
          <a class="secondary-action" v-on:click="$emit('addContact')">+ Add New Contact</a>
          <a class="secondary-action" v-on:click="$emit('addNote')">+ Add New Note</a>
        </div>
      </template>

      <template slot="source_template" slot-scope="data">
          <tr>
              <td>{{ data.row.date }}</td>
              <td>{{ data.row.contact_name }}</td>
              <td>{{ data.row.user }}</td>
              <td>{{ data.row.contact_method }}</td>
              <td>{{ data.row.notes }}</td>
          </tr>
      </template>
    </datatable>
  </div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import store from '@/store'

export default {
  name: 'CharityContactLog',
  props: ['charityId'],
  mounted () {
    this.refresh()
  },
  data () {
    return {
      columns: [
        { id: 'date', label: 'Date', sort: 'date_sort' },
        { id: 'contact_name', label: 'Contact Name' },
        { id: 'user', label: 'User' },
        { id: 'contact_method', label: 'Contact Method' },
        { id: 'notes', label: 'Notes' }
      ],
      isLoading: true,
      contactlog: []
    }
  },
  components: {
    Datatable,
    DatatableColumn
  },
  methods: {
    refresh () {
      store.functions.charity.getContactLog(this.charityId, (response) => {
        this.contactlog = response.data
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .buttons a {
    margin-left: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityContactLog.vue